import { Component, Input } from '@angular/core';
import { DataRowCardValuesModel } from 'libs/portal/src/modules/keepalive/models/SegmentedTile';

@Component({
  selector: 'app-data-value-row-card',
  templateUrl: './data-value-row-card.component.html',
  styleUrls: ['./data-value-row-card.component.scss'],
})
export class DataValueRowCardComponent {
  @Input() title: string;
  @Input() dataValues: DataRowCardValuesModel[];
  @Input() description: string;

  constructor() {}
}
